import clsx from 'clsx';

//type
import type { AlbumCardGridLayoutType, AlbumCardMedia } from '@/lib/albums/types';

import { getCardGridStyles } from '@/lib/albums/getCardGridStyles';
//libs
import { PINTEREST } from '@/lib/socialProfile';

//components
import { MediaGridImage } from '@/components/pages/albums/AlbumCardMediaGrid/MediaGridImage';

function MediaGridPinterest({
    medias,
    gridLayout
}: {
    medias: AlbumCardMedia[];
    gridLayout: AlbumCardGridLayoutType;
}) {
    const maxMedias = gridLayout === 'card' ? 4 : 3;
    const renderedMedias = medias.length > maxMedias ? medias.slice(0, maxMedias) : medias;

    return (
        <>
            {renderedMedias.map((media, index) => (
                <span
                    data-testid={`grid-pinterest-${media.type}`}
                    key={media.text}
                    className={clsx(
                        {
                            'row-span-9': medias.length === 3 && index === 0
                        },
                        getCardGridStyles({
                            index: index + 1,
                            size: renderedMedias?.length,
                            network: PINTEREST,
                            gridLayout
                        })
                    )}>
                    <MediaGridImage
                        index={index}
                        image={media.medias?.[0]?.image ?? media?.medias?.[0]?.thumbnail}
                        type={media?.type}
                        size={medias?.length}
                        gridLayout={gridLayout}
                    />
                </span>
            ))}
        </>
    );
}

export default MediaGridPinterest;
